<mat-tab-group id="tab-group">s
    <mat-tab label="Performance">
        <ng-template matTabContent>
            <main-extended-dashboard [user]="user"></main-extended-dashboard>
        </ng-template>
    </mat-tab>
</mat-tab-group>